'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedList from 'I18n/components/FormattedList';
import text from 'I18n/utils/unescapedText';
import { mapStateToProps as mapEditorErrorsStateToProps } from 'DesignComponents/statusBar/connect/editorErrors';
import UIStatusTag from 'UIComponents/tag/UIStatusTag';
import UIButton from 'UIComponents/button/UIButton';

function mergeProps(stateProps, dispatchProps, ownProps) {
  const {
    toggleDrawer,
    isDrawerOpen
  } = ownProps;
  const {
    isOpenDrawerRequested,
    errorsCount,
    warningsCount,
    hasMessages
  } = stateProps;
  return {
    isDrawerOpen,
    toggleDrawer,
    isOpenDrawerRequested,
    errorsCount,
    warningsCount,
    hasMessages
  };
}

const statusBarI18nKey = key => `DesignEditorsUI.statusBar.header.${key}`;

class StatusBarStatus extends Component {
  constructor(...args) {
    super(...args);

    this.renderHeaderDetailsList = () => {
      const {
        errorsCount,
        warningsCount
      } = this.props;
      const detailsList = [];
      const connector = text(statusBarI18nKey('connector'));

      if (errorsCount) {
        detailsList.push( /*#__PURE__*/_jsx(FormattedMessage, {
          message: statusBarI18nKey('errorTypes.error'),
          options: {
            count: errorsCount
          }
        }, "error"));
      }

      if (warningsCount) {
        detailsList.push( /*#__PURE__*/_jsx(FormattedMessage, {
          message: statusBarI18nKey('errorTypes.warning'),
          options: {
            count: warningsCount
          }
        }, "warning"));
      }

      if (!detailsList.length) {
        detailsList.push(this.renderNoErrorsMessage());
      }

      return /*#__PURE__*/_jsx(FormattedList, {
        twoWordsConnector: connector,
        children: detailsList
      });
    };
  }

  componentDidUpdate() {
    const {
      hasMessages
    } = this.props;

    if (!hasMessages && this.props.isDrawerOpen) {
      this.props.toggleDrawer(false, null);
    } else if (hasMessages && this.props.isOpenDrawerRequested && !this.props.isDrawerOpen) {
      this.props.toggleDrawer(true);
    } else if (hasMessages && this.props.isDrawerOpen) {
      this.props.toggleDrawer(true);
    }
  }

  get tagUse() {
    if (this.props.errorsCount) return 'error';
    if (this.props.warningsCount) return 'warning';
    return 'success';
  }

  renderNoErrorsMessage() {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: statusBarI18nKey('noErrors')
    });
  }

  renderStatusText() {
    if (!this.props.hasMessages) {
      return this.renderNoErrorsMessage();
    }

    const buttonTitleKey = this.props.isDrawerOpen ? 'hide' : 'show';
    return [/*#__PURE__*/_jsx(FormattedReactMessage, {
      message: statusBarI18nKey('foundMessage'),
      options: {
        list: this.renderHeaderDetailsList()
      }
    }, "text"), /*#__PURE__*/_jsx(UIButton, {
      use: "link",
      className: "status-details-button",
      onClick: this.props.toggleDrawer,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: statusBarI18nKey(`showDetailsButton.${buttonTitleKey}`)
      })
    }, "error-link")];
  }

  render() {
    return /*#__PURE__*/_jsx(UIStatusTag, {
      className: "status-bar__status",
      use: this.tagUse,
      children: this.renderStatusText()
    }, "status-tag");
  }

}

StatusBarStatus.propTypes = {
  toggleDrawer: PropTypes.func.isRequired,
  isOpenDrawerRequested: PropTypes.bool,
  errorsCount: PropTypes.number.isRequired,
  warningsCount: PropTypes.number.isRequired,
  hasMessages: PropTypes.bool.isRequired,
  isDrawerOpen: PropTypes.bool.isRequired
};
export default connect(mapEditorErrorsStateToProps, null, mergeProps)(StatusBarStatus);